import React from "react";
import { useTranslation } from "react-i18next";
import LoginWrapper from "./LoginWrapper";

function UnknownUserView({ onUnknownUserBack, email }) {
  const { t } = useTranslation("auth");
  return (
    <LoginWrapper
      left={
        <form>
          <div>
            <h1>{t("unknownUser.title")}</h1>
          </div>

          <label htmlFor="email" data-has-error>
            {t("unknownUser.emailLabel")}
          </label>
          <div className="relative">
            <input
              type="email"
              name="email"
              value={email}
              disabled
              data-has-error
              sz="large"
            />
            <span role="input-error" />
          </div>

          <p className="error">{t("unknownUser.invalidEmail")}</p>

          <div className="chip danger mt-3">
            {t("unknownUser.chipMessage")}
          </div>

          <button
            data-button-type="primary"
            sz="large"
            onClick={onUnknownUserBack}
          >
            {t("unknownUser.back")}
          </button>

          <a
            data-button-type="outline"
            role="button"
            sz="large"
            href="https://mystrengthbook.com/contact/"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4!"
          >
            <span>{t("unknownUser.contactUs")}</span>
          </a>
        </form>
      }
    />
  );
}

export default UnknownUserView;
